import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import TextInput from '../TextInput';

const Wrapper = styled.div`
    display: flex;
    align-items: center;
`;

const IconStyled = styled.svg`
    box-sizing: content-box;
    width: 1.5em;
    color: ${({ theme }) => theme.color.highlightColor};
    margin-left: calc(-2.25em - 1px);
    padding: 0.5em;
    cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
`;

const InputStyled = styled(TextInput)`
    padding-right: 2.5em;
`;

function InputWithIcon(props) {
    const { Icon = () => null, onIconClick = () => {}, ...propsMin } = props;
    return (
        <Wrapper>
            <InputStyled {...propsMin} />
            <IconStyled as={Icon} onClick={onIconClick} />
        </Wrapper>
    );
}

InputWithIcon.propTypes = {
    Icon: PropTypes.node,
    onIconClick: PropTypes.func,
};

export default InputWithIcon;
